import { AutogenLayoutInvoiceProcessingDeleteDialog } from "./autogen/AutogenLayoutInvoiceProcessingDeleteDialog";

export class InvoiceProcessingDeleteDialog extends AutogenLayoutInvoiceProcessingDeleteDialog {
    onSwitchClick() {
        this.textboxHoldReason.enabled = this.switchHold.checked;
        if (!this.switchHold.checked) {
            this.textboxHoldReason.text = "";
            this.textboxHoldReason.required = false;
        } else {
            this.textboxHoldReason.required = true;
        }
    }
}